/** Local midnight for license end (YYYY-MM-DD or Date) for calendar-day math. */
export function parseLicenseEndToLocalDate(value) {
  if (value == null || value === '') return null;
  const s = String(value).trim();
  const iso = s.match(/^(\d{4}-\d{2}-\d{2})/);
  if (iso) {
    const [y, m, d] = iso[1].split('-').map(Number);
    const dt = new Date(y, m - 1, d);
    if (
      dt.getFullYear() !== y ||
      dt.getMonth() !== m - 1 ||
      dt.getDate() !== d
    ) {
      return null;
    }
    return dt;
  }
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return null;
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

/** Whole calendar days from start of today to end date (negative if already expired). */
export function getCalendarDaysUntilLicenseEnd(licenseEndValue) {
  const end = parseLicenseEndToLocalDate(licenseEndValue);
  if (!end) return null;
  const t = new Date();
  const start = new Date(t.getFullYear(), t.getMonth(), t.getDate());
  return Math.round((end.getTime() - start.getTime()) / 86400000);
}

/** License end is strictly before today (calendar days). */
export function isHcpLicenseExpired(row) {
  const days = getCalendarDaysUntilLicenseEnd(row?.license_end_date);
  return days != null && days < 0;
}

/** Not expired, end date within the next 30 calendar days (0–30 inclusive). */
export function isHcpLicenseExpiringWithin30DaysNotExpired(row) {
  const days = getCalendarDaysUntilLicenseEnd(row?.license_end_date);
  return days != null && days >= 0 && days <= 30;
}

/** Non-overlapping bands: ≤30 (includes expired), 31–60, 61–90. */
export function renewalBand(row, band) {
  const days = getCalendarDaysUntilLicenseEnd(row?.license_end_date);
  if (days == null) return false;
  if (band === '30') {
    return days <= 30;
  }
  if (band === '60') {
    return days >= 31 && days <= 60;
  }
  if (band === '90') {
    return days >= 61 && days <= 90;
  }
  return false;
}
